export const bonuses = [
  {
    name: 'La Bible du Comping Jazz',
    kicker: 'La',
    title: 'Bible du Comping',
    subtitle: 'Jazz',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4c427d23-f2e0-4e4b-8b3c-e3f7905a8f14.jpg',
    description:
      "Voicings drop 2 et drop 3, rythmes Charleston, comping walking et shells de Freddie Green. Tout ce qu'il faut pour que vos élèves accompagnent comme de vrais musiciens de jazz.",
    pages: '84 pages',
    value: 37,
  },
  {
    name: 'Maîtrise du ii-V-I dans les 12 Tonalités',
    kicker: 'Maîtrise du',
    title: 'ii-V-I',
    subtitle: 'dans les 12 tonalités',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0d34dc42-dc4d-4e71-be17-db8952cabaf3.jpg',
    description:
      'La cadence la plus importante du jazz, décomposée tonalité par tonalité : arpèges, notes-guides, lignes de liaison et exercices progressifs prêts à imprimer.',
    pages: '96 pages',
    value: 37,
  },
  {
    name: 'Bibliothèque Express des Standards Jazz',
    kicker: 'Bibliothèque Express des',
    title: 'Standards',
    subtitle: 'Jazz',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/437a38e1-9736-49a4-b234-9ac4f932df8d.jpg',
    description:
      "30 standards incontournables avec grilles simplifiées, analyses harmoniques et parcours d'apprentissage en 4 étapes pour chaque morceau.",
    pages: '120 pages',
    value: 47,
  },
  {
    name: 'Guide de Survie pour Jam Session Jazz',
    kicker: 'Guide de Survie pour',
    title: 'Jam Session',
    subtitle: 'Jazz',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/839b437f-f14c-4d1e-91a2-20032fb0a5c0.jpg',
    description:
      'Étiquette de la jam, signaux sur scène, intros et fins classiques, trading fours. Préparez vos élèves à monter sur scène sans paniquer.',
    pages: '64 pages',
    value: 27,
  },
  {
    name: 'Masterclass de Transcription Jazz',
    kicker: 'La',
    title: 'Masterclass',
    subtitle: 'de Transcription Jazz',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b839f16a-29bc-455a-93ab-3012cd8f7a70.jpg',
    description:
      "Une méthode pas à pas pour apprendre à relever les solos des maîtres à l'oreille, avec 12 solos transcrits, annotés et découpés en phrases.",
    pages: '88 pages',
    value: 37,
  },
];
